module.exports = __webpack_public_path__ + "static/media/cifar3.781af702.png";